import { PlusIcon, Trash2Icon } from 'lucide-react'
import { useState } from 'react'

import { IconButton, Select, Table } from 'slab'
import type { PartnersPartnerAdmin } from 'utils/web_api.schemas'

import { PartnerAdminRelationshipRoleSelector } from './PartnerAdminRelationshipRoleSelector'

const COLUMN_WIDTHS = {
  name: 320,
  role: 160,
  date: 128,
} as const

interface AddPartnerAdminRelationshipRowProps {
  availablePartnerAdmins: PartnersPartnerAdmin[]
  onAdd: (partnerAdminId: string, role: string) => void
  onCancel: () => void
  hasExistingAssignee: boolean
  isSubmitting?: boolean
}

export const AddPartnerAdminRelationshipRow = ({
  availablePartnerAdmins,
  onAdd,
  onCancel,
  hasExistingAssignee,
  isSubmitting = false,
}: AddPartnerAdminRelationshipRowProps) => {
  const [selectedPartnerAdminId, setSelectedPartnerAdminId] = useState<string>('')
  const [selectedRole, setSelectedRole] = useState<string>('viewer')

  const handleAdd = () => {
    if (selectedPartnerAdminId && selectedRole) {
      onAdd(selectedPartnerAdminId, selectedRole)
    }
  }

  const canAdd = selectedPartnerAdminId && selectedRole

  const formatPartnerAdminLabel = (admin: PartnersPartnerAdmin) => {
    const roles = admin.roles?.length ? ` (${admin.roles.map(r => r.charAt(0).toUpperCase() + r.slice(1)).join(', ')})` : ''
    return `${admin.email}${roles}`
  }

  return (
    <Table.Row>
      <Table.Cell width={COLUMN_WIDTHS.name}>
        <Select
          value={selectedPartnerAdminId}
          onChange={(e) => setSelectedPartnerAdminId(e.target.value)}
        >
          <option value=''>Select partner admin...</option>
          {availablePartnerAdmins.map((admin) => (
            <option key={admin.id} value={admin.id}>
              {formatPartnerAdminLabel(admin)}
            </option>
          ))}
        </Select>
      </Table.Cell>
      <Table.Cell width={COLUMN_WIDTHS.role}>
        <PartnerAdminRelationshipRoleSelector
          currentRole={selectedRole}
          onChange={setSelectedRole}
          hasExistingAssignee={hasExistingAssignee}
          hideLabel
        />
      </Table.Cell>
      <Table.ActionsCell colSpan={2}>
        <div className='flex gap-2'>
          <IconButton
            icon={Trash2Icon}
            label='Cancel'
            variant='secondary'
            size='medium'
            onClick={onCancel}
            disabled={isSubmitting}
          />
          <IconButton
            icon={PlusIcon}
            label='Add'
            variant='primary'
            size='medium'
            onClick={handleAdd}
            disabled={!canAdd || isSubmitting}
          />
        </div>
      </Table.ActionsCell>
    </Table.Row>
  )
}
